import PropTypes from 'prop-types';

import BEM from '@scripts/utilities/bem.js';
import { percentNumberFormatter, percentNumberFormatterNoSign } from '@scripts/utilities/numbers.js';


export default function(React) {
  /**
   * A simple component that displays a given number as a percentage,
   * highlighting the figure in green when it' positive.
   */
  class PercentageFigure extends React.Component {
    render() {
      var variant;
      if (this.props.highlightPositive && (this.props.amount > 0)) {
        variant = 'positive';
      }

      var amount;
      if (this.props.displaySign) {
        amount = percentNumberFormatter.format(this.props.amount);
      } else {
        amount = percentNumberFormatterNoSign.format(this.props.amount);
      }

      return (
        <span className={BEM.classString('cs-figure', variant)}>
          {amount}%
        </span>
      );
    }
  }


  PercentageFigure.propTypes = {
    amount: PropTypes.number,
    highlightPositive: PropTypes.bool,
    displaySign: PropTypes.bool
  };

  PercentageFigure.defaultProps = {
    amount: 0,
    highlightPositive: true,
    displaySign: true
  };


  return PercentageFigure;
};

